import { administrationRequests } from "api/administrationApi";
import { createExporter } from "utils/createExporter";
import { SemestersChoices } from "utils/choices";
import { INCOMPLETE_SEMESTERS } from "utils/constants";

const fileName = INCOMPLETE_SEMESTERS.replace(/[-/]/g, "_");

export const InterruptionsExporter = createExporter(
  `student_${fileName}.xlsx`,
  [
    { key: "facultyNumber", label: "Факултетен №" },
    { key: "firstName", label: "Име" },
    { key: "lastName", label: "Фамилия" },
    { key: "currentCourse", label: "Курс" },
    { key: "semester", label: "Семестър" },
    { key: "speciality", label: "Специалност" },
    { key: "attestations", label: "Липсващи заверк" },
  ],
  record => ({
    ...record,
    speciality: record.speciality?.name,
    semester: SemestersChoices.find(s => s.id === record.semester)?.name ?? "",
    attestations: record.attestations.length,
  }),
  [
    {
      source: "specialityId",
      target: administrationRequests.getSpecialitiesSelect(),
      name: "speciality",
    },
  ],
);
